import { render, staticRenderFns } from "./InfoPartner.vue?vue&type=template&id=39851e26&"
import script from "./InfoPartner.vue?vue&type=script&lang=js&"
export * from "./InfoPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports